class AboutVideo {
  #wrapperElement;

  #observer;

  #observerOptions = {
    threshold: 1,
    rootMargin: "0px",
  };

  constructor() {
    this.#wrapperElement = document.querySelector(`.js-about-video`);

    if (!this.#wrapperElement) return;

    this.observerCallback = this.observerCallback.bind(this);

    window.addEventListener(`load`, () => {
      this.#init();
    });
  }

  #init() {
    this.#observer = new IntersectionObserver(this.observerCallback, this.#observerOptions);

    this.#observer.observe(this.#wrapperElement);
  }

  #initPlayVideo() {
    const videoElement = this.#wrapperElement.querySelector("video");

    if (!videoElement) return;

    videoElement.play();
  }

  observerCallback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.intersectionRatio === 1) {
          this.#initPlayVideo();
          observer.disconnect();
        }
      }
    });
  }
}

export {AboutVideo};
